import { Edit } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import { GridCellParams, GridColDef } from "@mui/x-data-grid-premium";
import { Contact, ContactType } from "@repo/server-api";
import { RuleFactoryType } from "@repo/server-api/types";
import { useUserRoles, RuleComponent  } from "@repo/shared/components";
import { useTranslation } from "next-i18next";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { emptyContact } from "@repo/legacy/components/helper/Index";
import ConformationDialog from "@repo/legacy/components/shared/dialogs/Conformation";
import List from "@repo/legacy/components/shared/lists/List";

import { useAllContactsFullDataSource } from "../../components/shared/datasources/AllContactsFullDataSource";
import DialogCUEmployee from "../../components/shared/dialogs/DialogCUEmployee";

const Contacts = (props: { ruleFactory: RuleFactoryType }) => {
	const { t } = useTranslation();

	const navigate = useNavigate();
	const [openDialog, setOpenDialog] = useState<boolean>(false);

	const allContactDataSource = useAllContactsFullDataSource();

	const roles = useUserRoles();

	const columns: GridColDef<Contact>[] = [
		{
			field: "displayName",
			headerName: t("name"),
			width: 150,
			renderCell(params: GridCellParams) {
				return params.row.displayName;
			},
		},
		{
			field: "contactNumber",
			headerName: t("contact-number"),
			width: 150,
		},
		{
			field: "actions",
			headerName: t("actions"),
			sortable: false,
			align: "center",
			headerAlign: "center",
			width: 150,
			renderCell: (params: GridCellParams) => {
				const [openDeleteConformation, setOpenDeleteConformation] = useState<boolean>(false);

				const handleYes = (id: string) => {
					if (allContactDataSource.deleteData) allContactDataSource.deleteData(id, true);
					setOpenDeleteConformation(false);
				};
				const openDelete = () => {
					setOpenDeleteConformation(true);
				};

				return (
					<div>
						<Button
							data-testid="edit-button"
							onClick={() => navigate(`/employees/${encodeURIComponent(params.id)}`)}>
							<Edit />
						</Button>
						<Button data-testid="delete-button" onClick={() => openDelete()}>
							<DeleteIcon />
						</Button>
						<ConformationDialog
							text={t("contact.deleteConformation")}
							setOpenDeleteConformation={setOpenDeleteConformation}
							openPopup={openDeleteConformation}
							handleYes={() => handleYes(params.id.toString())}
						/>
					</div>
				);
			},
		},
	];

	return (
		<>
			<DialogCUEmployee
				contact={{
					...emptyContact,
					contactTypes: [ContactType.Employee],
				}}
				refreshData={(member: Contact) => {
					setTimeout(() => navigate(`/employees/${encodeURIComponent(member.id)}`), 500);
				}}
				contactType={ContactType.Employee}
				setOpen={setOpenDialog}
				open={openDialog}
				showContractorSelection={true}
				ruleFactory={props.ruleFactory}
			/>

			<h3 className="purpleHeader">{t("employees")}</h3>
			<List
				columns={columns as GridCellParams<Contact>[]}
				dataSource={allContactDataSource}
				showDeletedFilter={true}
				contactTypes={[ContactType.Employee, ContactType.Person]}>
				<RuleComponent
					rule={() => roles.roles.includes("contractor_hr") || roles.roles.includes("tenant_hr")}>
					<Button
						data-testid="contact-dialog-button"
						className="blueButton right"
						color="secondary"
						variant="contained"
						onClick={() => {
							setOpenDialog(true);
						}}>
						{t("create-new-employee")} <AddIcon />
					</Button>
				</RuleComponent>
			</List>
		</>
	);
};

export default Contacts;
